import { DEFAULT_STATION_DISTANCE } from '../../interfaces/filters';
import { IThunkActionCreator } from '../../types/store';
import { normalizeNameForSearch } from '../../utils/geo';
import { commuteSuggestSort, commuteSuggestUpdater } from '../../utils/roads';
import { doesStationMatchRequest } from '../../utils/stations';
import { ActionTypes, IStationsFiltered } from './actions';
import { IRailwaySuggest } from './index';

export function filterStations(value: string, distance: number = DEFAULT_STATION_DISTANCE): IThunkActionCreator {
  return (dispatch, getState) => {
    const {
      stations: { currentStations, regionHasStations, selectedStations },
      villageList: { stationData },
    } = getState();

    if (!value || !regionHasStations) {
      dispatch<IStationsFiltered>({
        stations: [],
        type: ActionTypes.StationsFiltered,
      });

      return;
    }
    const normalizedValue = normalizeNameForSearch(value);
    const filteredStations = (currentStations as IRailwaySuggest[])
      .filter(station => doesStationMatchRequest(station, normalizedValue))
      .map(commuteSuggestUpdater(stationData as Record<number, number>, selectedStations, distance))
      .sort(commuteSuggestSort);

    dispatch<IStationsFiltered>({
      stations: filteredStations,
      type: ActionTypes.StationsFiltered,
    });
  };
}
